import { useActiveStructureNode } from "../../AppActor/actors/treeState/hooks";
import { useAppSelector } from "../../../redux/hooks";
import { selectIsDetailsDebugEnabled } from "../../../redux/debugSlice";

export default function DetailsDebug(): JSX.Element {
	const isEnabled = useAppSelector(selectIsDetailsDebugEnabled);
	const node = useActiveStructureNode();
	return isEnabled ? <pre>{JSON.stringify(node, null, 2)}</pre> : <></>;
}
